// Same rules as backend/rate_tiers.py: a tier applies from its threshold (« à partir de »).
export const tierFor = (tiers, cad) => {
  const list = tiers && tiers.length ? tiers : [{ above_cad: 0, rate: 0 }];
  let t = list[0];
  for (const x of list) if ((Number(cad) || 0) >= x.above_cad - 1e-9) t = x;
  return t;
};
export const tierRate = (tiers, cad) => tierFor(tiers, cad).rate;
export const nextTier = (tiers, cad) => (tiers || []).find(x => x.above_cad > (Number(cad) || 0)) || null;
export const welcomeFcfa = (bonus, cap, cad) => (bonus > 0 ? Math.round(Math.min(Number(cad) || 0, cap) * bonus) : 0);
// CAD needed for a given FCFA received (tier rate + optional welcome bonus on the first `cap` dollars)
export const cadForFcfa = (tiers, fcfa, bonus = 0, cap = 0) => {
  const f = Number(fcfa) || 0;
  for (const t of [...(tiers || [])].reverse()) {
    let cad = bonus > 0 && f <= cap * (t.rate + bonus) ? f / (t.rate + bonus) : (f - (bonus > 0 ? cap * bonus : 0)) / t.rate;
    if (cad >= t.above_cad - 1e-9) return Math.max(0, cad);
  }
  return 0;
};
export const fmtRate = (r) => Number(r || 0).toLocaleString('fr-FR', { maximumFractionDigits: 2 });
